'use client';

import { Accordion, Text } from '@skin-seoul/design-system';
import React from 'react';
import { exploreProductCategories } from '@skin-seoul/service';
import { SafeLink } from '@/components/ui/SafeLink';
import { CLASSNAME } from '@skin-seoul/service';
const ExploreProductAccordion = () => {
  return <Accordion.Root display="flex" flexDirection="column" gap={4} multiple data-sentry-element="Accordion.Root" data-sentry-component="ExploreProductAccordion" data-sentry-source-file="ExploreProductAccordion.tsx">
      {exploreProductCategories.map(category => <Accordion.Item key={category.id} value={category.category}>
          <Accordion.ItemTrigger backgroundColor="primary.50" borderRadius="4px" _expanded={{
        borderRadius: '4px 4px 0 0'
      }} justifyContent="space-between" cursor="pointer" padding={4}>
            <Text color="primary.500" fontWeight="regular" textStyle={{
          base: 'paragraph.small',
          tablet: 'paragraph.small'
        }} className={CLASSNAME.NOT_TRANSLATE}>
              {category.category}
            </Text>
            <Accordion.ItemIndicator color="primary.500" />
          </Accordion.ItemTrigger>
          <Accordion.ItemContent backgroundColor="primary.50" borderRadius="0 0 4px 4px" borderTop="1px solid" borderTopColor="primary.100" display="flex" flexDirection={{
        base: 'column',
        tablet: 'row'
      }} flexWrap="wrap" gap={4} padding={6}>
            {category.subCategories.map(subCategory => <SafeLink href={subCategory.link} key={subCategory.name}>
                <Text _hover={{
            color: 'neutral.500'
          }} color="neutral.800" fontWeight="regular" textStyle="paragraph.small" className={CLASSNAME.NOT_TRANSLATE}>
                  {subCategory.name}
                </Text>
              </SafeLink>)}
          </Accordion.ItemContent>
        </Accordion.Item>)}
    </Accordion.Root>;
};
export default ExploreProductAccordion;